import request from '@/utils/request'

/**
 * @apiName 计费方式查询
 * @apiUrl
 */
export function getBillingMethod(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/config/getBillingMethod',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 余额查询
 * @apiUrl
 */
export function getBalance(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/fund/manage/balance/get',
    method: 'POST',
    data,
  })
}

/**
 * @apiName OCR开关查询
 * @apiUrl
 */
export function getOcrStatus(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/config/ocr/get',
    method: 'POST',
    data,
  })
}

/**
 * @apiName OCR开关变更
 * @apiUrl
 */
export function updateOcrStatus(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/config/ocr/update',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取交易记录查询列表
 * @apiUrl
 */
export function getConstTradeList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/fund/manage/trade/list',
    method: 'POST',
    data,
  })
}


export function exportConstTradeList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/fund/manage/trade/export',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 通过 token 置换用户信息
 */
export function getCostCenterInfo() {
  return request({
    url: '/admin/v1/vehicle/finance/fund/manage/config/get',
    method: 'post',
    data: {},
  })
}

/**
 * 查询技术服务费账单 https://mock-test.cheweijia.com/project/10282/interface/api/492433
 * @param {Object} params - 查询参数
 * @param {number} params.billId - 账单ID
 * @param {string} params.dm - 账单月份
 * @param {number} params.amountType - 费用类型 (0: 基础技术服务费, 1: 支付宝支付技术服务费)
 * @param {number} params.billStatus - 账单状态 (1: 待确认账单, 2: 账单更新中, 3: 付款中, 4: 已完成)
 * @param {number} params.invoicingStatus - 开票状态 (0: 未开票, 1: 开票中, 2: 已开票, 3: 开票失败)
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页条数
 */
export function getServiceFeeInvoice({
  billId,
  dm,
  amountType,
  billStatus,
  invoicingStatus,
  pageNum,
  pageSize,
}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/finance/tech/list',
    method: 'post',
    data: {
      billId,
      dm,
      amountType,
      billStatus,
      invoicingStatus,
      pageNum,
      pageSize,
    },
  })
}

/**
 * 技术服务费-查询收款信息 https://mock-test.cheweijia.com/project/10282/interface/api/492449
 */
export function getPaymentInfo() {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/finance/tech/guidingInfo',
    method: 'post',
    data: {},
  })
}

/**
 * 技术服务费-确认账单 https://mock-test.cheweijia.com/project/10282/interface/api/492441
 * @param {number} billId 账单ID
 */
export function confirmBill(billId) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/finance/tech/confirmBill',
    method: 'post',
    data: { billId },
  })
}

/**
 * 查询开票接口 https://mock-test.cheweijia.com/project/10282/interface/api/492451
 * @param {number} billId 账单ID
 */
export function getInvoiceInfo(billId) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/finance/tech/getIssueInvoiceInfo',
    method: 'post',
    data: { billId },
  })
}

/**
 * 技术服务费-申请开票接口 https://mock-test.cheweijia.com/project/10282/interface/api/492453
 * @param {number} billId 账单ID
 */
export function applyInvoice(billId) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/finance/tech/issueInvoice',
    method: 'post',
    data: { billId },
  })
}

/**
 * 查询付款明细 https://mock-test.cheweijia.com/project/10282/interface/api/492445
 * @param {Object} params - 查询参数
 * @param {string} params.dm - 账单月份
 * @param {number} params.amountType - 费用类型 (0: 基础技术服务费, 1: 支付宝支付技术服务费)
 * @param {string} params.startDate - 付款开始时间
 * @param {string} params.endDate - 付款结束时间
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页条数
 */
export function getPaymentDetail({
  dm,
  amountType,
  startDate,
  endDate,
  pageNum,
  pageSize,
}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/finance/tech/deductionDetailsList',
    method: 'post',
    data: {
      dm,
      amountType,
      startDate,
      endDate,
      pageNum,
      pageSize,
    },
  })
}
